<template lang="pug">
  div(
    key="mediaCardBase"
    @click="!isMediaLibrary ? handleMedia() : null"
    :style="[styles.card.base(src, isActiveItem), ...viewSpecificStyles]"
    class="mediaCard box__shadow box__shadow--link"
    @mouseover="isMediaLibrary ? showOptions() : null"
    @mouseout="isMediaLibrary ? hideOptions() : null"
  )
    div(
      key="mediaCardCard"
      :style="cardSpecificStyles"
    )
      span(
        :style="styles.contentTag(contentType || 'video')"
      ) {{contentType || 'video'}}
      p {{title}}
</template>
<script>
import store from '../../store';
import { postResource } from '../../services/Utils.js';
import VueNotifications from 'vue-notifications';
import Services from '../../services/Services'
export default {
  name: 'mediaCard',
  props: {
    onClick: Function,
    isActionCard: Boolean,
    isTop: Boolean,
    media: Object,
    viewSpecificStyles: Object,
    cardSpecificStyles: Object,
    _id: String,
    src: String,
    isActiveItem: Boolean,
    isMediaLibrary: Boolean,
    contentType: String,
    content: String,
    title: String,
  },
  methods: {
    handleMedia() {
      console.log('clicking')
      if(this.isActionCard){
        this.onClick(true);
      } else {
        this.onClick(this.media);
        console.log('go to media');
        this.$router.push('/media/' + store.getters.getActiveMedia._id);
      }
    },
    showOptions() {
      this.visibleOptions = true;
    },
    hideOptions() {
      this.visibleOptions = false;
    },
    showSuccess() {
      // give cards a little time to move
      setTimeout(() => {
        this.showSuccessMsg({ message: 'Media moved to top!' });
      }, 400);
    },
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data() {
    return {
      visibleOptions: false,
      tagColors: {
        video: {
          bg: '#09a3ed',
          text: '#fff'
        },
        image: {
          bg: 'purple',
          text: '#fff'
        },
        audio: {
          bg: 'green',
          text: '#fff'
        },
        pdf: {
          bg: 'orange',
          text: '#444'
        }
      },
      styles: {
        card: {
          base: (src, active) => ({
            backgroundImage: `linear-gradient(to top, rgba(0,0,0,1), rgba(0,0,0,0)), url(${
              this.src
            })`,
            backgroundSize: 'cover',
            flex: '0 0 auto',
            margin: '10px',
            height: '250px',
            display: 'flex',
            flexFlow: 'column nowrap',
            justifyContent: 'flex-end',
            color: '#fff',
            fontWeight: '400',
            fontSize: '1em',
            textAlign: 'left',
            padding: '20px',
            opacity: active ? 1 : 0.8,
            border: '0',
            transition: 'all 75ms ease-out'
          })
        },
        title: {
          margin: '10px 0 0',
          fontWeight: '700',
          lineHeight: '1.25rem'
        },
        contentTag: type => ({
          background: this.tagColors[type].bg || '#888',
          display: 'inline',
          color: this.tagColors[type].text || '#fff',
          padding: '5px',
          borderRadius: '4px',
          fontSize: '0.7em',
          fontWeight: '700',
          textTransform: 'uppercase'
        })
      }
    };
  }
};
</script>
<style lang="scss" scoped>
.mediaCard {
  position: relative;
}
.window {
  background: rgba(0,0,0,0.6);
  position: absolute;
  cursor: default;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;

  button {
    margin: 0 1rem;
    border-width: 2px !important;
  }
}

</style>




// WEBPACK FOOTER //
// src/components/general/MediaCard.vue